import styled from "styled-components";

interface InfoStatusProps {
  color: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  svg {
    width: 35px;
    height: 35px;
  }
`;

const Info = styled.div`
  font-size: 15px;
  display: flex;
  align-items: center;
  margin-left: 6px;
  white-space: nowrap;
  overflow: hidden;
`;

const InfoDescritpion = styled.div`
  margin-left: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 15px;
`;

const InfoDetails = styled.div`
  display: flex;
  > :first-child {
    margin-right: 8px;
  }
`;

const InfoDetailItem = styled.div`
  font-size: 13px;
  color: #666666;

  .title {
    font-weight: 700;
    color: #000;
  }
`;

const InfoStatus = styled.span<InfoStatusProps>`
  color: ${({ color }) => color};
  font-weight: 600;
`;

interface IconContainerProps {
  color: string;
}

const IconContainer = styled.div<IconContainerProps>`
  svg {
    fill: ${({ color }) => color};
  }
`;

const IconActionContainer = styled.div`
  color: #bebebe;

  svg {
    width: 20px;
  }
`;

export {
  Container,
  Info,
  InfoStatus,
  IconContainer,
  IconActionContainer,
  InfoDescritpion,
  InfoDetails,
  InfoDetailItem
};
